import React from "react";
import Leadcaremanagers from "components/caremanager/Leadcaremanagers";
const Leadcaremanager = () => {
  return (
    <>
      <div className="main-contents">
        <h1 className="heading-h5">Care Managers</h1>
        <Leadcaremanagers />
      </div>
    </>
  );
};

export default Leadcaremanager;
